export default "__VITE_ASSET__Bv8CJT9T__"